export default __webpack_public_path__ + "static/Thatch-00e6b5ec1908a3253ae5424d3e26ffe2.png";